<div class="site-diary-entry-sidenav">
  <ng-template #toggleWidthTemplate>
    <div
      class="sidenav-title-toggle-width align-content-center justify-content-center mr-3"
      (click)="toggleWidth()"
    >
      <img
        draggable="false"
        [src]="
          taskSidenavService.isExpandedWidth()
            ? '/assets/img/sidenav-collapse.svg'
            : '/assets/img/sidenav-expand.svg'
        "
        alt=""
      />
    </div>
  </ng-template>

  <ng-template #titleTemplate>
    @if (entry) {
      <div class="site-diary-entry-sidenav__title-content">
        <mat-icon
          class="site-diary-entry-sidenav__type-icon"
          [style.color]="isControlDocumentation ? '#dc3f3f' : typeConfig.foregroundColor"
          [style.backgroundColor]="
            isControlDocumentation ? 'rgba(220, 63, 63, 0.14)' : typeConfig.backgroundColor
          "
          fontSet="material-icons-round"
          >{{ isControlDocumentation ? 'search' : typeConfig.icon }}</mat-icon
        >
        <h2>
          {{ isControlDocumentation ? controlDocumentationTitle : typeLabel }}
        </h2>
      </div>
    }
  </ng-template>

  <ng-template #headerActionsTemplate>
    @if (canDeleteDocumentation) {
      <div
        class="sidenav-title-edit align-content-center justify-content-center site-diary-entry-sidenav__delete"
        [class.site-diary-entry-sidenav__delete--disabled]="deleting"
        (click)="delete()"
      >
        <img draggable="false" src="/assets/img/ic-trash-red-v2.svg" alt="" />
      </div>
    }
  </ng-template>

  <sidenav-title
    [leadingActionsTemplate]="toggleWidthTemplate"
    [titleTemplate]="titleTemplate"
    [customActionsTemplate]="headerActionsTemplate"
    [closeFunc]="close.bind(this)"
    [wrap]="true"
  />

  @if (loading) {
    <div class="site-diary-entry-sidenav__loading"><mat-spinner diameter="36" /></div>
  } @else if (entry) {
    <main class="site-diary-entry-sidenav__body">
      <section class="site-diary-entry-sidenav__section">
        <div class="card-v2-title mb-4">
          {{ 'ProjectsDashboard.siteDiaryEntrySidenav.description' | translate }}
        </div>
        @if (editingDescription) {
          <div class="site-diary-entry-sidenav__description-editor">
            <quill-editor
              [formControl]="descriptionControl"
              [modules]="descriptionModules"
              [formats]="quillFormats"
              class="quill-v2 quill-custom-img-size"
              [placeholder]="'Projects.enterDescription-note' | translate"
            />
          </div>
        } @else {
          <div class="site-diary-entry-sidenav__description" (click)="startDescriptionEdit()">
            <div class="ql-editor" [innerHTML]="entry.description || ''"></div>
          </div>
        }
      </section>

      <section class="site-diary-entry-sidenav__section">
        <div class="site-diary-entry-sidenav__section-header mb-4">
          <div class="card-v2-title">
            {{ 'ProjectsDashboard.siteDiaryEntrySidenav.media' | translate }}
          </div>
          @if (isControlDocumentation) {
            <app-button
              [matMenuTriggerFor]="addAttachmentMenu"
              [disabled]="uploadingMedia"
              [config]="{
                size: ButtonSize.LARGE,
                type: ButtonTypes.NEW_SECONDARY_NO_BORDER_BLUE,
                text: 'Attachments.addAttachments' | translate,
                prependSrc: './assets/img/paper-clip-icon.svg'
              }"
            />
            <mat-menu #addAttachmentMenu="matMenu" xPosition="before" class="menu-v2">
              <button mat-menu-item (click)="openMediaPicker(mediaInput)">
                <span>{{ 'Attachments.library.fromDevice' | translate }}</span>
              </button>
              <button mat-menu-item (click)="openAttachmentLibrary()">
                <span>{{ 'Attachments.library.fromDocuments' | translate }}</span>
              </button>
            </mat-menu>
            <input #mediaInput type="file" accept="image/*" multiple hidden (change)="uploadMedia($event)" />
          }
        </div>

        @if (media.length) {
          <div class="site-diary-entry-sidenav__media-grid">
            @for (item of media; track item.id) {
              <div class="site-diary-entry-sidenav__media-tile">
                <button
                  type="button"
                  class="site-diary-entry-sidenav__media-item"
                  (click)="triggerMediaPreview(item, $event)"
                >
                  @if (isImage(item) || isVideo(item)) {
                    <img [src]="item.thumbnailUrl" [alt]="item.name || ''" />
                    @if (isVideo(item)) {
                      <span class="site-diary-entry-sidenav__play"><mat-icon>play_arrow</mat-icon></span>
                    }
                  } @else {
                    <mat-icon class="site-diary-entry-sidenav__file-icon" fontSet="material-icons-round"
                      >description</mat-icon
                    >
                  }
                </button>
                <button
                  type="button"
                  class="site-diary-entry-sidenav__media-delete"
                  [disabled]="isMediaDeleting(item)"
                  [attr.aria-label]="'ProjectsDashboard.siteDiaryEntrySidenav.deleteMedia' | translate"
                  (click)="confirmDeleteMedia(item, $event)"
                >
                  @if (isMediaDeleting(item)) {
                    <mat-spinner diameter="14" />
                  } @else {
                    <svg-icon src="/assets/img/ic-trash-red-v2.svg" aria-hidden="true" />
                  }
                </button>
              </div>
              <a
                class="site-diary-entry-sidenav__preview-anchor"
                [href]="item.fileUrl"
                [attr.data-fancybox]="mediaGalleryId"
                [attr.data-site-diary-media-id]="item.id"
                [attr.data-caption]="item.name || item.file"
                [attr.data-type]="isVideo(item) ? 'video' : isImage(item) ? 'image' : 'iframe'"
              ></a>
            }
          </div>
        } @else {
          <p class="site-diary-entry-sidenav__media-empty">
            {{ 'ProjectsDashboard.siteDiaryEntrySidenav.emptyMedia' | translate }}
          </p>
        }
      </section>
    </main>
  } @else if (entryDeleted) {
    <div class="site-diary-entry-sidenav__state">
      <div class="site-diary-entry-sidenav__state-icon">
        <mat-icon fontSet="material-icons-round">delete_outline</mat-icon>
      </div>
      <h3>{{ 'ProjectsDashboard.siteDiaryEntrySidenav.deletedTitle' | translate }}</h3>
      <p>{{ 'ProjectsDashboard.siteDiaryEntrySidenav.deletedDescription' | translate }}</p>
    </div>
  } @else if (loadFailed) {
    <div class="site-diary-entry-sidenav__state">
      <p>{{ 'ProjectsDashboard.siteDiaryEntrySidenav.loadError' | translate }}</p>
      <app-button
        (onClick)="retryLoad()"
        [config]="{
          size: ButtonSize.LARGE,
          type: ButtonTypes.NEW_SECONDARY_BLUE,
          text: 'ProjectsDashboard.siteDiaryEntrySidenav.retry' | translate
        }"
      />
    </div>
  }

  @if (editingDescription) {
    <div class="sticky-footer d-flex justify-content-between">
      <app-button
        (onClick)="cancelDescriptionEdit()"
        [config]="{
          size: ButtonSize.LARGE,
          type: ButtonTypes.NEW_SECONDARY_BLUE_BACKGROUND,
          text: 'Projects.discard' | translate
        }"
      />
      <app-button
        (onClick)="saveDescriptionEdit()"
        [disabled]="savingDescription || !descriptionControl.dirty"
        [loading]="savingDescription"
        [config]="{
          size: ButtonSize.LARGE,
          type: ButtonTypes.NEW_PRIMARY_BLUE,
          text: 'Projects.saveAndEnd' | translate
        }"
      />
    </div>
  }
</div>
